@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

@if (AccessAllowed && pageReady) {
  <div class="p-3 flex flex-column flex-auto cf-page" [class.cf-compact]="isMobile">
    <div>
      <div class="text-900 font-medium text-xl mb-3"><h3>Scheduled Session
      </h3></div>
      <div class="surface-card p-4 shadow-2 border-round">
        <div class="grid formgrid p-fluid">
          <app-tabview class="col-12" [style]="{'width':'100%'}" [(activeIndex)]="activeIndex">
            <app-tabpanel header="Session Details" leftIcon="pi pi-list">
              <div class="field mb-4 col-12">
                <label for="classname" class="font-medium">Session Name</label>
                <input [(ngModel)]="ScheduledSession.name" id="classname" type="text" [ngStyle]="{'border-color': (scheduledsessionNameValid==false) ? '#FF0000':''}" (keyup)="DoValidCheck()" pInputText>
              </div>
              @if (!scheduledsessionNameValid) {
                <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Class name.</div>
              }
              <div class="field mb-4 col-12">
                <label for="classname" class="font-medium">Session Description</label>
                <!-- <textarea pInputText type="text" style="width:100%; height: 15vw;" [(ngModel)]="ScheduledSession.description"></textarea> -->
                <p-editor [(ngModel)]="ScheduledSession.description" [style]="{'height':'320px'}">
                  <ng-template #header>
                    <span class="ql-formats">
                      <p-header>
                        <span class="ql-formats">
                          <select class="ql-size">
                            <option value="small">Small</option>
                            <option selected value="normal">Normal</option>
                            <option value="large">Sub Heading</option>
                            <option value="huge">Heading</option>
                          </select>
                          <select class="ql-font">
                            <option selected value="san serif">San-Serif</option>
                            <option value="monospace">Monospace</option>
                            <option value="serif">Serif</option>
                          </select>
                        </span>
                        <span class="ql-formats">
                          <button class="ql-bold" aria-label="Bold"></button>
                          <button class="ql-italic" aria-label="Italic"></button>
                          <button class="ql-underline" aria-label="Underline"></button>
                          <button class="ql-strike" aria-label="Strike"></button>
                          <button class="ql-script" value="sub" title="Subscript"></button>
                          <button class="ql-script" value="super" title="Superscript"></button>
                          <button class="ql-indent" value="-1" title="Indent"></button>
                          <button class="ql-indent" value="+1" title="Outdent"></button>
                        </span>
                        <span class="ql-formats">
                          <select title="Text Color" class="ql-color" defaultValue="rgb(0, 0, 0)">
                          </select>
                          <span class="ql-format-separator"></span>
                          <select title="Background Color" class="ql-background" defaultValue="rgb(255, 255, 255)">
                          </select>
                        </span>
                        <span class="ql-formats">
                          <button class="ql-list" title="Ordered" value="ordered"></button>
                          <button class="ql-list" title="Bullet" value="bullet"></button>
                          <select title="Text Alignment" class="ql-align" >
                            <option label="Left"></option>
                            <option value="center" label="Center"></option>
                            <option value="right" label="Right"></option>
                            <option value="justify" label="Justify"></option>
                          </select>
                        </span>
                        <span class="ql-formats">
                          <button aria-label="Link" class="ql-link"></button>
                        </span>
                      </p-header>
                    </span>
                  </ng-template>
                </p-editor>
              </div>
              <div class="field mb-4 col-12">
                <label for="MembershipobjFile" class="font-medium">Upload a header image for your membership. The image must be smaller than 100KB</label>
                <div style="clear:both;width:100%">&nbsp;</div>
                <p-fileupload style="float:left;margin-right:10px;" mode="basic" [auto]="true" name="image" url="{{HTMLbmxurl}}/imageupload/{{VenueID}}/{{Identifier}}" accept="image/*" maxFileSize="100000" (onUpload)="uploadedFile($event)" (onError)="onErrorFileUpload($event)" chooseLabel="Upload File"></p-fileupload>
                @if (FileChosen != null && FileChosen != '') {
                  <button pButton pRipple type="button" style="float: left;margin-bottom: 10px;margin-top: 1px !important;height: 50px;" class="p-button-sm p-element p-button-danger w-auto mt-3" (click)="removeImage()">
                    <span style="margin-right:10px;" class="pi pi-times"></span>
                    Remove Image
                  </button>
                }
                <div style="clear:both;width:100%">&nbsp;</div>
                @if (FileChosen != null && FileChosen != '') {
                  <div>
                    <p style="margin-top:10px;">This is how your image will look in place.</p>
                    <div class="surface-card p-4 shadow-2 border-round packageCard" style="width: 460px;">
                      <div id="image">
                        <img src="{{ FileChosen }}" style="width: 460px;margin-top: -23px;margin-left: -23px;margin-right: -23px;">
                      </div>
                      <div style="font-weight: bold; padding: 20px;font-size:larger;">{{ScheduledSession.name}}</div>
                      <div style="padding-left: 20px; padding-right: 20px" [innerHTML]="">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum
                      </div>
                      <div>
                        <br><br>
                      </div>
                      <div>
                        <div>
                          <p-button label="Book this Session" icon="pi pi-check" style="width:420px;">
                          </p-button>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
              <div class="field mb-4 col-12" style="max-width: 500px;">
                <label for="venueclosingstartdate">Date</label>
                <p-datepicker [selectOtherMonths]="true" [(ngModel)]="ScheduledSessionDate" firstDayOfWeek="1" dateFormat="dd/mm/yy" [showIcon]="true" inputId="venueclosingstartdate"></p-datepicker>
                @if (!dateValid) {
                  <div class="text-danger" Style="margin-left:10px; margin-top: 0px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Date.</div>
                }
              </div>
              <div class="field mb-4 col-12" style="max-width: 500px;">
                <label for="venueclosingenddate">Time</label>
                <br>
                  <p-select [options]="TimeHours" [style]="{'width': '95px', 'float': 'left'}"  [(ngModel)]="ScheduledSessionTimeHours" optionValue="code" optionLabel="name"></p-select>
                  <span style="font-size: 29px;float: left;margin-left: 10px;margin-right: 10px;">:</span>
                  <p-select [options]="TimeMins" [style]="{'width': '95px', 'float': 'left'}"  [(ngModel)]="ScheduledSessionTimeMins" optionValue="code" optionLabel="name"></p-select>
                </div>
                <div style="clear:both; width:100%"></div>
                <div class="field mb-4 col-12" style="max-width: 500px; margin-top:20px">
                  <label for="classname" class="font-medium">Duration (In minutes)</label>
                  <p-inputnumber id="length" [showButtons]="true" max="99999" min="1" [(ngModel)]="ScheduledSession.duration" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
                </div>
                <div style="clear:both; width:100%"></div>
                <div class="field mb-4 col-12" style="max-width: 500px;">
                  <label for="classname" class="font-medium">Number of places</label>
                  <p-inputnumber id="length" [showButtons]="true" max="99999" min="1" [(ngModel)]="ScheduledSession.numberofplaces" (ngModelChange)="clampMaxBookings($event)" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
                </div>
                <div style="clear:both; width:100%"></div>
                <div class="field mb-4 col-12" style="max-width: 500px;">
                  <label for="numberofbookings" class="font-medium">Maximum bookings</label>
                  <p-inputnumber inputId="numberofbookings" [showButtons]="true" [max]="ScheduledSession.numberofplaces" min="0" [(ngModel)]="ScheduledSession.numberofbookings" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
                  <small class="block mt-1" style="color:#6c757d;">Set this to 0 for no limit, leaving the session capped only by the number of places.</small>
                </div>
                <div style="clear:both; width:100%"></div>
                <div class="field mb-4 col-12" style="max-width: 500px;">
                  <label for="classname" class="font-medium">Number of weeks this runs for:</label>
                  <p-inputnumber id="length" [showButtons]="true" max="52" min="1" [(ngModel)]="ScheduledSession.numberofweeks" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
                </div>
                <div style="clear:both; width:100%"></div>
                <div class="field mb-4 col-12">
                  <label for="packageRule" class="font-medium">Booking Questionnaire (Questionnaire must not contain birthday questions)</label>
                  <p-select [options]="BookingQuestionnaires" [(ngModel)]="ScheduledSession.questionnaire" placeholder="No Questionnaire" [showClear]="true" optionLabel="name" (onChange)="onQuestionnaireChange()"></p-select>
                </div>
                <div style="clear:both; width:100%"></div>
                <div class="field mb-4 col-12">
                  <label for="colour" class="font-medium">Colour</label>
                  <br />
                  <p-colorpicker [style]="{'margin-right': '10px'}" [inline]="false" id="colour" [(ngModel)]="ScheduledSession.colour"></p-colorpicker>
                  <input style="width:200px;" [(ngModel)]="ScheduledSession.colour" id="hexcolour" type="text" pInputText>
                </div>
                <div  class="field mb-4 col-12">
                  <label for="emailtemplate" class="font-medium">Email Template: (This template confirms the customer’s scheduled session details, usage instructions, and provides their scheduled session ID)</label>
                  <p-select [options]="EmailTemplates" placeholder="Select template" [(ngModel)]="ScheduledSession.emailtemplate" optionLabel="name" [showClear]="true"></p-select>
                </div>
                @if (!emailTemplateValid) {
                  <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must select an email template.</div>
                }
                <div class="col-12">
                  <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" (click)="next();">
                    Next
                    <span class="pi pi-angle-right" style="margin-left:8px;"></span>
                  </button>
                </div>
              </app-tabpanel>
              <app-tabpanel header="Resources" leftIcon="pi pi-clone">
                <div class="surface-card p-4 shadow-2 border-round" style="width:100%;float:left;">
                  @if (!isMobile) {
                    <div style="float:left; width:32%">
                      <div class="col-12 md:col-12 drag-column">
                        <span style="font-weight: bold;"> Available Resources </span>
                        <p-table [value]="availableResources">
                          <ng-template #header>
                            <tr>
                              <th style="width: 90%;">Name</th>
                              <th>&nbsp;</th>
                            </tr>
                          </ng-template>
                          <ng-template #body let-resource>
                            <tr>
                              @if (!resource.isresourcecontainer) {
                                <td><span class="pi pi-stop" style="margin-right: 10px;"></span>{{resource.name}}</td>
                              }
                              @if (resource.isresourcecontainer && !resource.isconstructed) {
                                <td><span class="pi pi-clone" style="margin-right: 10px;"></span>{{resource.name}}</td>
                              }
                              @if (resource.isresourcecontainer && resource.isconstructed) {
                                <td><span class="pi pi-sitemap" style="margin-right: 10px;"></span>{{resource.name}}</td>
                              }
                              <td>
                                <button pButton pRipple type="button" [style]="{'margin-bottom': '-6px', 'margin-top': '-4px !important'}" class="p-button-sm p-element p-button-success w-auto mt-3" (click)="AddToResources(resource)">
                                  <span class="pi pi-angle-right"></span>
                                </button>
                              </td>
                            </tr>
                          </ng-template>
                        </p-table>
                        @if (availableResources.length == 0) {
                          <div style="padding: 15px;">
                            <i>No resources available</i>
                          </div>
                        }
                      </div>
                    </div>
                  }
                  <div class="cf-col" style="float:left; width:65%">
                    <div class="col-12 md:col-12 drop-column" pDroppable="resources">
                      <!-- On a phone the Available list is this dropdown instead - see addPicked. -->
                      @if (isMobile) {
                        <div class="cf-add-row">
                          <p-select [options]="availableResources" [(ngModel)]="picked['resources']" [ngModelOptions]="{standalone: true}" optionLabel="name" placeholder="Add a resource"
                          [filter]="true" filterBy="name" appendTo="body" emptyMessage="None available"></p-select>
                          <button pButton pRipple type="button" class="p-button-success"
                            [disabled]="picked['resources'] == null" (click)="addPicked('resources', AddToResources)"><span class="p-button-icon p-button-icon-left pi pi-plus" aria-hidden="true"></span><span class="p-button-label">Add</span></button>
                          </div>
                        }
                        <span style="font-weight: bold;"> Selected Resources </span>
                        <p-table [value]="ScheduledSession.resources">
                          <ng-template #header>
                            <tr>
                              <th style="width: 90%;">&nbsp;</th>
                              <th>&nbsp;</th>
                            </tr>
                          </ng-template>
                          <ng-template #body let-resource>
                            <tr>
                              @if (!resource.isresourcecontainer) {
                                <td><span class="pi pi-stop" style="margin-right: 10px;"></span>{{resource.name}}</td>
                              }
                              @if (resource.isresourcecontainer && !resource.isconstructed) {
                                <td><span class="pi pi-clone" style="margin-right: 10px;"></span>{{resource.name}}</td>
                              }
                              @if (resource.isresourcecontainer && resource.isconstructed) {
                                <td><span class="pi pi-sitemap" style="margin-right: 10px;"></span>{{resource.name}}</td>
                              }
                              <td>
                                <button pButton pRipple type="button" [style]="{'margin-bottom': '-6px', 'margin-top': '-4px !important'}" class="p-button-sm p-element p-button-danger w-auto mt-3" (click)="removeFromResources(resource)">
                                  <span class="pi pi-angle-left"></span>
                                </button>
                              </td>
                            </tr>
                          </ng-template>
                        </p-table>
                        @if (ScheduledSession.resources == null || ScheduledSession.resources.length == 0) {
                          <div style="padding: 15px;">
                            <i>No resources selected</i>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                  <div style="clear:both;width:100%">&nbsp;</div>
                  <div class="col-12">
                    <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" (click)="nextRes();">
                      Next
                      <span class="pi pi-angle-right" style="margin-left:8px;"></span>
                    </button>
                    &nbsp;
                    <button pButton pRipple type="button" class="p-button p-element p-button-danger w-auto mt-3" (click)="returnToList()">
                      <span class="pi pi-times" style="margin-right:8px;"></span>
                    Cancel</button>
                  </div>
                </app-tabpanel>
                <app-tabpanel header="Admissions" leftIcon="pi pi-user">
                  <div class="surface-card p-4 shadow-2 border-round" style="width:100%;float:left;">
                    @if (!isMobile) {
                      <div style="float:left; width:32%">
                        <div class="col-12 md:col-12 drag-column">
                          <span style="font-weight: bold;"> Available Admissions </span>
                          <p-table [value]="availableAdmissions">
                            <ng-template #header>
                              <tr>
                                <th style="width: 90%;">Name</th>
                                <th>&nbsp;</th>
                              </tr>
                            </ng-template>
                            <ng-template #body let-admission>
                              <tr>
                                <td><span class="pi pi-user" style="margin-right: 10px;"></span>{{admission.name}}</td>
                                <td>
                                  <button pButton pRipple type="button" [style]="{'margin-bottom': '-6px', 'margin-top': '-4px !important'}" class="p-button-sm p-element p-button-success w-auto mt-3" (click)="AddToAdmissions(admission)">
                                    <span class="pi pi-angle-right"></span>
                                  </button>
                                </td>
                              </tr>
                            </ng-template>
                          </p-table>
                          @if (availableAdmissions.length == 0) {
                            <div style="padding: 15px;">
                              <i>No admissions available</i>
                            </div>
                          }
                        </div>
                      </div>
                    }
                    <div class="cf-col" style="float:left; width:65%">
                      <div class="col-12 md:col-12 drop-column" pDroppable="admissions">
                        <!-- On a phone the Available list is this dropdown instead - see addPicked. -->
                        @if (isMobile) {
                          <div class="cf-add-row">
                            <p-select [options]="availableAdmissions" [(ngModel)]="picked['admissions']" [ngModelOptions]="{standalone: true}" optionLabel="name" placeholder="Add an admission"
                            [filter]="true" filterBy="name" appendTo="body" emptyMessage="None available"></p-select>
                            <button pButton pRipple type="button" class="p-button-success"
                              [disabled]="picked['admissions'] == null" (click)="addPicked('admissions', AddToAdmissions)"><span class="p-button-icon p-button-icon-left pi pi-plus" aria-hidden="true"></span><span class="p-button-label">Add</span></button>
                            </div>
                          }
                          <span style="font-weight: bold;"> Selected Admissions </span>
                          <p-table [value]="ScheduledSession.membershipadmissions">
                            <ng-template #header let-columns>
                              <tr>
                                <th>&nbsp;</th>
                                <th>&nbsp;</th>
                                <th>&nbsp;</th>
                                <th class="row-move-cell"></th>
                              </tr>
                            </ng-template>
                            <ng-template #body let-admission let-columns="columns" let-index="rowIndex">
                              <tr [pReorderableRow]="index">
                                <td>
                                  <span class="pi pi-bars" pReorderableRowHandle></span>
                                </td>
                                <td>
                                  <app-accordion style="background-color: white !important; margin-top: 5px; border: none;" expandIcon="pi pi-chevron-right" collapseIcon="pi pi-chevron-down">
                                    <app-accordiontab style="background-color: white !important; margin-top: 5px; border: none;">
                                      <ng-template pTemplate="header">
                                        <div style="width:100%">
                                          <span class="pi pi-user" style="margin-right: 10px;"></span>{{admission.name}} &nbsp;(Min:&nbsp;{{admission.min}},&nbsp;Max:&nbsp;{{admission.max}},&nbsp;Price:&nbsp;{{admission.price | currency:this.CurrencySymbol}})
                                        </div>
                                      </ng-template>
                                      <div class="surface-card p-4 shadow-2 border-round">
                                        <div class="grid formgrid p-fluid">
                                          <div class="field mb-4 col-12">
                                            <label for="quantity" class="font-medium">Minimum</label>
                                            <p-inputnumber [(ngModel)]="admission.min" [showButtons]="true" buttonLayout="horizontal" mode="decimal"></p-inputnumber>
                                          </div>
                                          <div class="field mb-4 col-12">
                                            <label for="ResourceOpt" class="font-medium">Maximum</label>
                                            <p-inputnumber [(ngModel)]="admission.max" [showButtons]="true" buttonLayout="horizontal" mode="decimal"></p-inputnumber>
                                          </div>
                                          @if (admission.max < admission.min) {
                                            <div class="text-danger" Style="margin-left:10px; margin-top: -15px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>Max admissions must be greater ot equal to Min admissions.</div>
                                          }
                                          <div class="field mb-4 col-12">
                                            <label for="quantity" class="font-medium">Price:</label>
                                            <p-inputnumber  [(ngModel)]="admission.price" [showButtons]="true" buttonLayout="horizontal" mode="currency" currency="{{CurrencySymbol}}"></p-inputnumber>
                                          </div>
                                          <div class="field mb-4 col-12">
                                            <label for="quantity" class="font-medium">Details Required:</label>
                                            <p-selectbutton id="ppar" [options]="stateOptions" [(ngModel)]="admission.detailsrequired" ></p-selectbutton>
                                          </div>
                                        </div>
                                      </div>
                                    </app-accordiontab>
                                  </app-accordion>
                                </td>
                                <td>
                                  <button pButton pRipple type="button" [style]="{'margin-bottom': '10px'}" class="p-button-sm p-element p-button-danger w-auto mt-3" (click)="removeFromAdmissions(admission)">
                                    <span class="pi pi-angle-left"></span>
                                  </button>
                                </td>
                                <td class="row-move-cell"><app-row-move [list]="ScheduledSession.membershipadmissions" [index]="index"></app-row-move></td>
                              </tr>
                            </ng-template>
                          </p-table>
                        </div>
                      </div>
                    </div>
                    @if (!admissionsValid) {
                      <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must select at least one admission.</div>
                    }
                    <div class="col-12">
                      <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" (click)="updateData();">
                        <span class="pi pi-pencil" style="margin-right:8px;"></span>
                      Save Changes</button>
                      `       &nbsp;
                      <button pButton pRipple type="button" class="p-button p-element p-button-danger w-auto mt-3" (click)="returnToList()">
                        <span class="pi pi-times" style="margin-right:8px;"></span>
                      Cancel</button>
                    </div>
                  </app-tabpanel>
                  <div style="clear:both;width:100%">&nbsp;</div>
                </app-tabview>
              </div>
            </div>
          </div>
        </div>
      }